const prefix = 'BILLING';

export const CREATE_SETUP_INTENT = Symbol(`${prefix}/CREATE_SETUP_INTENT`);
export const CREATE_SETUP_INTENT_SUCCESS = Symbol(`${prefix}/CREATE_SETUP_INTENT_SUCCESS`);
export const CREATE_SETUP_INTENT_FAIL = Symbol(`${prefix}/CREATE_SETUP_INTENT_FAIL`);

export const ATTACH_PAYMENT_METHOD = Symbol(`${prefix}/ATTACH_PAYMENT_METHOD`);
export const ATTACH_PAYMENT_METHOD_SUCCESS = Symbol(`${prefix}/ATTACH_PAYMENT_METHOD_SUCCESS`);
export const ATTACH_PAYMENT_METHOD_FAIL = Symbol(`${prefix}/ATTACH_PAYMENT_METHOD_FAIL`);

export const GET_BILLING_INFO = Symbol(`${prefix}/GET_BILLING_INFO`);
export const GET_BILLING_INFO_SUCCESS = Symbol(`${prefix}/GET_BILLING_INFO_SUCCESS`);
export const GET_BILLING_INFO_FAIL = Symbol(`${prefix}/GET_BILLING_INFO_FAIL`);

export const GET_INVOICE_PREVIEWS = Symbol(`${prefix}/GET_INVOICE_PREVIEWS`);
export const GET_INVOICE_PREVIEWS_SUCCESS = Symbol(`${prefix}/GET_INVOICE_PREVIEWS_SUCCESS`);
export const GET_INVOICE_PREVIEWS_FAIL = Symbol(`${prefix}/GET_INVOICE_PREVIEWS_FAIL`);

export const ADD_PROMO_OR_REFERRAL = Symbol(`${prefix}/ADD_PROMO_OR_REFERRAL`);
export const ADD_PROMO_OR_REFERRAL_SUCCESS = Symbol(`${prefix}/ADD_PROMO_OR_REFERRAL_SUCCESS`);
export const ADD_PROMO_OR_REFERRAL_FAIL = Symbol(`${prefix}/ADD_PROMO_OR_REFERRAL_FAIL`);

export const SET_PAUSE_SUBSCRIPTION = Symbol(`${prefix}/SET_PAUSE_SUBSCRIPTION`);
export const SET_PAUSE_SUBSCRIPTION_SUCCESS = Symbol(`${prefix}/SET_PAUSE_SUBSCRIPTION_SUCCESS`);
export const SET_PAUSE_SUBSCRIPTION_FAIL = Symbol(`${prefix}/SET_PAUSE_SUBSCRIPTION_FAIL`);

export const SUBSCRIBE = Symbol(`${prefix}/SUBSCRIBE`);
export const SUBSCRIBE_SUCCESS = Symbol(`${prefix}/SUBSCRIBE_SUCCESS`);
export const SUBSCRIBE_FAIL = Symbol(`${prefix}/SUBSCRIBE_FAIL`);

export const PAUSE_SUBSCRIPTION = Symbol(`${prefix}/PAUSE_SUBSCRIPTION`);
export const PAUSE_SUBSCRIPTION_SUCCESS = Symbol(`${prefix}/PAUSE_SUBSCRIPTION_SUCCESS`);
export const PAUSE_SUBSCRIPTION_FAIL = Symbol(`${prefix}/PAUSE_SUBSCRIPTION_FAIL`);

export const RENEW_SUBSCRIPTION = Symbol(`${prefix}/RENEW_SUBSCRIPTION`);
export const RENEW_SUBSCRIPTION_SUCCESS = Symbol(`${prefix}/RENEW_SUBSCRIPTION_SUCCESS`);
export const RENEW_SUBSCRIPTION_FAIL = Symbol(`${prefix}/RENEW_SUBSCRIPTION_FAIL`);

export const TRIAL = Symbol(`${prefix}/TRIAL`);
export const TRIAL_SUCCESS = Symbol(`${prefix}/TRIAL_SUCCESS`);
export const TRIAL_FAIL = Symbol(`${prefix}/TRIAL_FAIL`);
export const CANCEL_TRIAL = Symbol(`${prefix}/CANCEL_TRIAL`);

export const UNSUBSCRIBE = Symbol(`${prefix}/UNSUBSCRIBE`);
export const UNSUBSCRIBE_SUCCESS = Symbol(`${prefix}/UNSUBSCRIBE_SUCCESS`);
export const UNSUBSCRIBE_FAIL = Symbol(`${prefix}/UNSUBSCRIBE_FAIL`);

export const RESUME_SUBSCRIPTION = Symbol(`${prefix}/RESUME_SUBSCRIPTION`);
export const RESUME_SUBSCRIPTION_SUCCESS = Symbol(`${prefix}/RESUME_SUBSCRIPTION_SUCCESS`);
export const RESUME_SUBSCRIPTION_FAIL = Symbol(`${prefix}/RESUME_SUBSCRIPTION_FAIL`);

export const UPDATE_CUSTOMER_ADDRESS = Symbol(`${prefix}/UPDATE_CUSTOMER_ADDRESS`);
export const UPDATE_CUSTOMER_ADDRESS_SUCCESS = Symbol(`${prefix}/UPDATE_CUSTOMER_ADDRESS_SUCCESS`);
export const UPDATE_CUSTOMER_ADDRESS_FAIL = Symbol(`${prefix}/UPDATE_CUSTOMER_ADDRESS_FAIL`);

export const CLOSE_UPDATE_MODAL = Symbol(`${prefix}/CLOSE_UPDATE_MODAL`);
